import { Component, Input, OnInit } from '@angular/core';
import { IColumn, ITableOptions } from '@modeso/aumico-lib-core-fe';
import { INotesTypeEntityDTO } from '@modeso/types__aumico-lib-notes-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import Debug from 'debug';
import { INotesTypesWithSingleLanguage } from '../../../interfaces/INotesTypesWithSingleLanguage.interface';
import { NotesTypesMapper } from '../../../mappers/notesTypes.mapper';
import { NotesProvider } from '../../../provider/notes.provider';
import { INotesTypesListDelegate } from './INotesTypesListDelegate.interface';

const debug = Debug('aumico:aumico-lib-notes-fe:NotesTypesListPage');

@UntilDestroy()
@Component({
    selector: 'aumico-notes-types-list-page',
    templateUrl: 'notes-types-list.page.html',
    styleUrls: ['notes-types-list.page.scss'],
})
export class NotesTypesListPage implements OnInit {
    @Input() public set injectedProviderSetter(injectedProvider: NotesProvider) {
        if (injectedProvider) {
            this.provider = injectedProvider;
        }
    }

    @Input() language = 'de-ch';
    DELEGATE?: INotesTypesListDelegate;
    @Input() public set delegate(delegate: INotesTypesListDelegate) {
        if (delegate) {
            this.DELEGATE = delegate;
        }
    }

    protected subscriptions = [];
    columns: IColumn[];
    isBackendReturnError = false;
    backendErrors: string;

    data: INotesTypesWithSingleLanguage[];
    options: ITableOptions;
    readonly serverError = 'Internal Server Error';

    constructor(private provider: NotesProvider, private notesTypesMapper: NotesTypesMapper) {
        this.prepareTableOptions();
    }

    ngOnInit(): void {
        this.provider.dispatchNotesTypes();
        this.provider.getNotesTypes$().pipe(untilDestroyed(this)).subscribe(this.handleGetNotesTypes.bind(this));
    }

    handleGetNotesTypes(notesTypes: INotesTypeEntityDTO[]) {
        if (notesTypes) {
            this.data = this.notesTypesMapper.getNotesTypesWithLanguage(notesTypes, this.language);
            debug('ngOnInit getNotesTypes result');
            debug(notesTypes);
        }
    }

    onRowButtonClicked(id: string, action?: string): void {
        debug(`1 Row with Id ${id} clicked for action ${action}`);
        this.provider.selectActiveNotesType(id);
        this.DELEGATE.onAddOrUpdateNotesTypeClicked();
    }

    onAddNewNotesType(): void {
        this.DELEGATE.onAddOrUpdateNotesTypeClicked();
    }

    prepareTableOptions() {
        this.columns = [
            { name: 'name', type: 'text', property: 'name' },
            { name: 'title', type: 'truncated-text', property: 'title' },
            { name: 'edit', type: 'button', property: '_id', action: 'edit' },
        ];

        this.options = {
            columns: this.columns,
        };
    }
}
